/**
 * @module store/emails/actions
 *
 * @version 1.0.1
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetEmails, apiDeleteEmails } from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getEmails = async ({ commit, rootGetters }, { limit, offset }) => {
  commit(types.GET_EMAILS_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetEmails(userSession.accessToken.jwtToken, { limit, offset });

      commit(types.GET_EMAILS_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('Неавторизованный пользователь не может получить список e-mail.');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_EMAILS_ASYNC.FAILURE);
  }
};


/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getAllEmails = async ({ rootGetters }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data } = await apiGetEmails(userSession.accessToken.jwtToken, {});
      return data;
    } else {
      throw new Error('Неавторизованный пользователь не может получить список e-mail.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Delete emails
 *
 * @since Version 1.0.1
 */
const deleteEmails = async ({ rootGetters }, emails) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeleteEmails(userSession.accessToken.jwtToken, emails);
    } else {
      throw new Error('Неавторизованный пользователь не может получить список ордеров.');
    }
  } catch (error) {
    console.log(error);
  }
};

export default {
  deleteEmails,
  getAllEmails,
  getEmails,
};
